import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const activePartnerApi = createAsyncThunk(
  "aadhar",
  async ({ name = "", startDate = "", endDate = "" }) => {
    const params = {};

    // Add name to the query if provided
    if (name) {
      params.name = name;
    }

    // Add date range to the query if provided
    if (startDate) {
      params.startDate = startDate;
    }
    if (endDate) {
      params.endDate = endDate;
    }

    const response = await axiosInstance.get("/active_partner_data", {
      params, // Pass the parameters to the API request
    });
    if (response) {
      return response.data;
    }
  }
);

const activePartnerSlice = createSlice({
  name: "activePartner",
  initialState: {
    activePartner: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(activePartnerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(activePartnerApi.fulfilled, (state, action) => {
        state.activePartner = action.payload;
        state.loading = false;
      })
      .addCase(activePartnerApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default activePartnerSlice.reducer;
